const PREFIX = 'playerv.resume.'

export const ResumeStore = {
  key(explicit: string | undefined, fingerprint: string | undefined) {
    return explicit || fingerprint || 'default'
  },

  load(key: string): number | null {
    try {
      const raw = localStorage.getItem(PREFIX + key)
      if (!raw) return null
      const n = Number(raw)
      return Number.isFinite(n) && n > 0 ? n : null
    } catch {
      return null
    }
  },

  save(key: string, time: number) {
    try {
      localStorage.setItem(PREFIX + key, String(Math.floor(time)))
    } catch {
      /* ignore */
    }
  },

  clear(key: string) {
    try {
      localStorage.removeItem(PREFIX + key)
    } catch {
      /* ignore */
    }
  },

  /** Offer resume if between 5% and 95% of duration */
  offer(saved: number | null, duration: number): number | null {
    if (saved == null || !duration || duration < 30) return null
    if (saved < duration * 0.05 || saved > duration * 0.95) return null
    return saved
  },
}
